import memoizee from "memoizee";
import * as m from "qpr-base/api/model";

export const getPeriods = memoizee((id: string) => m.getPeriods(id), {
  //promise: true,
});
